goog.module('yext.developerapps.salesforcereviews.ConfigureWorkflow');
goog.module.declareLegacyNamespace();

const yext = goog.require('yext');
const DialogView = goog.require('yext.apps.common.DialogView');
const routes = goog.require('yext.developerapps.routes');
const Filter = goog.require('yext.developerapps.common.Filter');

/**
 * @constructor
 */
const ConfigureWorkflow = function() {
  this.$ctxt = $('.js-workflow-details');
  this.filter = new Filter(this.$ctxt);
  this.deleteDialog = new DialogView(this.$ctxt.find('.js-delete-workflow-dialog'));
  this.init();
};

ConfigureWorkflow.prototype.init = function() {
  this.filter.init();
  this.deleteDialog.init();
  this.bindAddFilter();
  this.bindSaveWorkflow();
  this.bindDeleteWorkflow();
  this.bindUpdateForm();
};

goog.exportSymbol('yext.developerapps.salesforcereviews.ConfigureWorkflow', ConfigureWorkflow);

ConfigureWorkflow.prototype.bindAddFilter = function() {
  var controller = this;
  this.$ctxt.find('.js-add-filter-btn').on('click', function() {
    controller.filter.addFilter();
  });
};

ConfigureWorkflow.prototype.bindSaveWorkflow = function() {
  var controller = this;
  this.$ctxt.find('.js-save-add-btn').on('click', function() {
    controller.saveWorkflow(function(result) {
      if (result['success']) {
        window.location.reload();
      } else if (result['errors']) {
        controller.handleSaveErrors(result['errors']);
      } else {
        controller.showGenericError(yext.msg('Error saving workflow.'));
      }
    });
  });

  this.$ctxt.find('.js-save-btn').on('click', function() {
    controller.saveWorkflow(function(result) {
      if (result['success']) {
        window.location = routes.SalesforceReviews.listWorkflows();
      } else if (result['errors']) {
        controller.handleSaveErrors(result['errors']);
      } else {
        controller.showGenericError(yext.msg('Error saving workflow.'));
      }
    });
  });
};

ConfigureWorkflow.prototype.bindDeleteWorkflow = function() {
  var controller = this;
  var id = this.$ctxt.find('input[name=id]').val();
  this.$ctxt.find('.js-delete-btn').on('click', function() {
    controller.deleteDialog.show();
  });

  this.$ctxt.find('.js-confirm-delete').on('click', function() {
    $.ajax({
      method: 'DELETE',
      url: routes.SalesforceReviews.deleteWorkflow({'id': id}),
    }).done(function(result) {
      controller.deleteDialog.hide();
      if (result['success']) {
        window.location = routes.SalesforceReviews.listWorkflows();
      } else {
        controller.showGenericError(yext.msg('Error deleting workflow.'));
      }
    });
  });
};

ConfigureWorkflow.prototype.saveWorkflow = function(successCallback) {
  var workflow = {};
  workflow['id'] = this.$ctxt.find('input[name=id]').val();
  workflow['name'] = this.$ctxt.find('input[name="workflow.name"]').val();
  workflow['priority'] = this.$ctxt.find('select[name="workflow.priority"]').val();
  workflow['locationName'] = this.$ctxt.find('select[name="workflow.locationName"]').val();
  workflow['entityId'] = this.$ctxt.find('select[name="workflow.entityId"]').val();
  workflow['address'] = this.$ctxt.find('select[name="workflow.address"]').val();
  workflow['country'] = this.$ctxt.find('select[name="workflow.country"]').val();
  workflow['accountName'] = this.$ctxt.find('select[name="workflow.accountName"]').val();
  workflow['publisher'] = this.$ctxt.find('select[name="workflow.publisher"]').val();
  workflow['rating'] = this.$ctxt.find('select[name="workflow.rating"]').val();
  workflow['publisherDate'] = this.$ctxt.find('select[name="workflow.publisherDate"]').val();
  workflow['workflowName'] = this.$ctxt.find('select[name="workflow.workflowName"]').val();
  workflow['reviewLink'] = this.$ctxt.find('select[name="workflow.reviewLink"]').val();
  workflow['authorName'] = this.$ctxt.find('select[name="workflow.authorName"]').val();
  workflow['authorEmail'] = this.$ctxt.find('select[name="workflow.authorEmail"]').val();
  var responseEnabled = this.$ctxt.find('select[name="workflow.responseEnabled"]').val();
  if (responseEnabled === 'YES') {
    workflow['responseEnabled'] = true;
  } else {
    workflow['responseEnabled'] = false;
  }
  workflow['filters'] = [];
  this.$ctxt.find('.js-workflow-filter').not('.js-workflow-filter-template').each(function() {
    var type = $(this).find('select[name=type]').val();
    var value = $(this).find('.js-filter-value').val();
    value = value == null ? '' : value;
    if (type) {
      if (Array.isArray(value)) {
        workflow['filters'].push({'type': type, 'value': value.join(',')});
      } else {
        workflow['filters'].push({'type': type, 'value': value});
      }
    }
  });

  $.ajax({
    method: 'POST',
    url: routes.SalesforceReviews.saveWorkflow(),
    data: JSON.stringify(workflow),
    contentType: 'application/json',
  })
    .done(successCallback);
};

/**
 * @param {List<Object>} errors contains objects with fieldName and errorMessage properties.
 */
ConfigureWorkflow.prototype.handleSaveErrors = function(errors) {
  var controller = this;
  $.each(errors, function(i, error) {
    var fieldName = error['fieldName'];
    var errorMessage = error['errorMessage'].replace('\n', '<br>');
    if (fieldName === 'general') {
      controller.showGenericError(errorMessage);
    } else if (fieldName === 'filter') {
      var filterIndex = error['index'];
      var $filterContainer = controller.$ctxt.find('.js-filter-field');
      if (filterIndex !== undefined) {
        var filterElement = $filterContainer.find('.js-workflow-filter')
          .not('.js-workflow-filter-template')
          .get(filterIndex);
        $(filterElement).find('.js-field-error')
          .text(errorMessage)
          .show();
        $(filterElement).find('input[type=text], select, .js-filter-value')
          .addClass('error');
      } else {
        $filterContainer.find('.js-field-error.js-unindexed-error')
          .text(errorMessage)
          .show();
      }
    } else {
      var $field = controller.$ctxt.find('.js-' + fieldName + '-field');
      $field.find('.js-field-error')
        .text(errorMessage)
        .show();
      $field.find('input[type=text], select')
        .addClass('error');
    }
  });
};

ConfigureWorkflow.prototype.showGenericError = function(errorMessage) {
  this.$ctxt.find('.js-general-error')
    .text(errorMessage)
    .show();
};

ConfigureWorkflow.prototype.bindUpdateForm = function() {
  var controller = this;
  $(this).on('formUpdated', function() {
    controller.$ctxt.find('.js-field-error, js-general-error')
      .empty()
      .hide();
    controller.$ctxt.find('input.error, select.error, .js-filter-value.error')
      .removeClass('error');
  });

  this.$ctxt.on('change', 'input, select', function() {
    $(controller).trigger('formUpdated');
  });

  $(this.filter).on('filterUpdated', function() {
    $(controller).trigger('formUpdated');
  });
};

exports = ConfigureWorkflow;
